import VerticalPage from "@/components/marketing/VerticalPage";
import { ShoppingBag, Layers, Receipt, Wallet, Zap, BarChart3 } from "lucide-react";

export default function Malls() {
  return (
    <VerticalPage
      vertical="Malls"
      hero={"One cart. Twelve vendors. Zero queue drama."}
      blurb={"Multi-vendor food courts run on Grubpe: unified order capture across kiosk, app, web QR and POS — with per-vendor KOTs, per-vendor GST, and weekly auto-settlement."}
      palette={{
        badge:  "bg-rose-50 text-rose-700",
        iconBg: "bg-rose-50 text-rose-700",
        kpi:    "bg-rose-50 text-rose-900 border border-rose-200",
      }}
      kpis={[
        { value: "12+",   label: "Vendors / court" },
        { value: "60s",   label: "Avg ticket time" },
        { value: "T+7",   label: "Vendor settlement" },
        { value: "1",     label: "Cart for all vendors" },
      ]}
      features={[
        { icon: ShoppingBag, title: "Self-serve kiosks",        desc: "Touchscreen kiosks per court with brand-aware menus, dietary filters, allergen flags and instant UPI / card payment." },
        { icon: Layers,      title: "Multi-vendor cart",         desc: "A single cart with biryani from vendor A, pizza from vendor B, dessert from vendor C — three KOTs, one payment." },
        { icon: Receipt,     title: "Per-vendor GST invoices",   desc: "Each line item invoices against its own vendor's GSTIN. No more lumping all sales under the food-court operator." },
        { icon: Wallet,      title: "Weekly auto-settlement",    desc: "Money flows from a single nodal account to vendors on a rolling 7-day cycle. Reconciled. Auditable. Zero spreadsheets." },
        { icon: Zap,         title: "Order-status pager",        desc: "SMS / app push when each KOT is ready. Customers free up tables faster. Throughput goes up without seat overflow." },
        { icon: BarChart3,   title: "Footfall vs. revenue",      desc: "Hour-by-hour live dashboard. Spot the lunch-time vendor bottleneck before the queue spills onto the elevator bay." },
      ]}
      useCases={[
        "Lunch rush at 1 PM: 230 carts cleared in 14 minutes across 8 vendors, all KOTs printed in under 1.2 seconds.",
        "Vendor adds a new SKU at 11 AM: live on every kiosk, app, and POS by 11:01 AM — no APK update, no reboot.",
        "End-of-week settlement: ₹14.2 L revenue split across 12 vendors with TDS, commission, and chargebacks reconciled in one report.",
        "Mall ops team gets an automatic anomaly ping: 'Counter 6 idle for 45 min' → on-call manager dispatched.",
      ]}
    />
  );
}
